import { SR_API_ACTION_LOGONAS } from 'api/actionTypes';

export default async function logonas({ state, apiClient }, { phone, partnerId, redirectUrl }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_LOGONAS,
    state: state,
    payload: {
      phone,
      partnerId,
    },
    onSuccess() {
      if (redirectUrl) {
        global.location.replace(redirectUrl);
      } else {
        global.location.reload();
      }
    },
  });
}
